export default "__VITE_ASSET__D_GKWh70__"